"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var session_metric_collector_1 = require("./../../services/metric-collectors/session-metric-collector");
var require_non_null_1 = require("./../../util/require-non-null");
/**
 * Implementations of {@link SessionMetricCollectorBuilder}
 */
var SessionMetricCollectorBuilderImpl = /** @class */ (function () {
    function SessionMetricCollectorBuilderImpl() {
        this.reset();
    }
    /**
     * @inheritdoc
     */
    SessionMetricCollectorBuilderImpl.prototype.reset = function () {
        this.exportToPrometheusProp = false;
        this.groupByPropertiesProp = [];
        this.removesMetricsWithNoMatchesProp = false;
        return this;
    };
    /**
     * @inheritdoc
     */
    SessionMetricCollectorBuilderImpl.prototype.exportToPrometheus = function (exportMetrics) {
        this.exportToPrometheusProp = exportMetrics;
        return this;
    };
    /**
     * @inheritdoc
     */
    SessionMetricCollectorBuilderImpl.prototype.groupByProperty = function (propertyName) {
        this.groupByPropertiesProp.push(require_non_null_1.requireNonNull(propertyName, 'propertyName is null'));
        return this;
    };
    /**
     * @inheritdoc
     */
    SessionMetricCollectorBuilderImpl.prototype.groupByProperties = function (propertyNames) {
        this.groupByPropertiesProp = require_non_null_1.requireNonNull(propertyNames, 'propertyNames is null');
        return this;
    };
    /**
     * @inheritdoc
     */
    SessionMetricCollectorBuilderImpl.prototype.removeMetricsWithNoMatches = function (remove) {
        this.removesMetricsWithNoMatchesProp = remove;
        return this;
    };
    /**
     * @inheritdoc
     */
    SessionMetricCollectorBuilderImpl.prototype.create = function (name, sessionFilter) {
        return new session_metric_collector_1.SessionMetricCollectorImpl(require_non_null_1.requireNonNull(name, 'name is null'), this.exportToPrometheusProp, this.removesMetricsWithNoMatchesProp, require_non_null_1.requireNonNull(sessionFilter, 'sessionFilter is null'), this.groupByPropertiesProp);
    };
    return SessionMetricCollectorBuilderImpl;
}());
exports.SessionMetricCollectorBuilderImpl = SessionMetricCollectorBuilderImpl;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/features/metrics/session-metric-collector-builder.js
// module id = 1266
// module chunks = 0